export class KeyToString {
    /**
     * Appends a key press to a string, handling special keys like Backspace.
     * @param key The key that was pressed (e.g., "a", "Backspace", "Enter")
     * @param targetString The current string to append to
     * @returns The updated string after applying the key press
     */
    public static appendKeyToString(key: string, targetString: string): string {
        if (key === "Backspace") {
            if (targetString.length <= 1)
                return "";
            else
                return targetString.substring(0, targetString.length - 1);
        }
        if (key.length > 1)
            return targetString;
        return targetString + key;
    }
}
